import { clearModal, showNotification } from 'actions';
import { LOST_REALTIME_SOCKET_CONNECTION } from 'constants/ModalTypes';
import checkRealtimeSocketConnection from 'actions/CheckRealtimeSocketConnection';
import { StudioLogger } from '@studio/logger/StudioLogger';
import getCurrentBroadcast from '@shoflo/studio-redux/actions/broadcast/getCurrentBroadcast';

const LOG = new StudioLogger('SocketDispatcher');

/**
 * Handles the realtime connection restoration after a reconnect event.
 * Clears the connection lost modal, shows a success notification,
 * clears any pending timeout, fetches the current broadcast state,
 * and logs the restoration event.
 *
 * @param {Object} socket - The socket.io socket instance
 * @param {Object} store - The Redux store instance
 * @returns {void}
 */
const socketReconnected = (socket, store) => {
  const socketIOSocket = socket.eject();
  socketIOSocket.io.on('reconnect', () => {
    LOG.info(`Socket reconnected. Checking realtime connection...`);

    store.dispatch(clearModal(LOST_REALTIME_SOCKET_CONNECTION));
    store.dispatch(
      showNotification('Realtime connection restored', {
        type: 'success',
        timeout: 1000 * 3
      })
    );

    clearTimeout(globalThis.realtimeConnectionLostTimeout);
    globalThis.realtimeConnectionLostTimeout = null;
    store.dispatch(getCurrentBroadcast(true));

    const {
      meeting: { attendeeResponse }
    } = store.getState();
    const payload = {
      attendeeId: attendeeResponse?.Attendee?.AttendeeId ?? 'unavailable'
    };
    LOG.error('Realtime connection restored', payload);
  });
  store.dispatch(checkRealtimeSocketConnection());
};

export { socketReconnected };
